import api from "./api";

export interface clientData {
    name: string,
    email_address: string,
    address: string,
    country: string,
    properties?: any
}

export interface propertyData {
    name: string,
    contact_name: string,
    email_address: string,
    address: string,
}

export interface meterData {
    name: string,
    meter_type: string,
    meter_number: string,
    location: string,
    utility_id: string,
    Si_unit: string,
    site_id: string,
    images: any
}

export const getClients = async (): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/portfolios/clients`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Clients");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const addClient = async (data: clientData): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.post(`/portfolios/clients`, data, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to add Client");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
}

export const editClient = async (clientId: string, data: clientData): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.put(`/portfolios/clients/${clientId}`, data, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to add Client");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
}

export const getProperties = async (clientId: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/portfolios/clients/${clientId}/properties`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Clients");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getProperty = async (clientId: string, propertyId: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/portfolios/clients/${clientId}/properties/${propertyId}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Clients");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getPropertyMeters = async (clientId: string, propertyId: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/portfolios/clients/${clientId}/properties/${propertyId}/meters`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Clients");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getPropertyUtilities = async (clientId: string, propertyId: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/portfolios/clients/${clientId}/properties/${propertyId}/utilities`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Clients");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getUtilities = async (): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/bills/utilities`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Utility Suppliers");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getUtility = async (utilityId: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/bills/utilities/${utilityId}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        // console.log(response)

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Utility Suppliers");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getPropertyUtilityMeters = async (clientId: string, propertyId: string, utilityId: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/portfolios/clients/${clientId}/properties/${propertyId}/utilities/${utilityId}/meters`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Clients");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const addProperty = async (clientId: string, data: propertyData): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.post(`/portfolios/clients/${clientId}/properties`, data, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to add Property");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
}

export const editProperty = async (clientId: string, data: propertyData, propertyId: string): Promise<any> => {
    try {
        const token = localStorage.getItem("token");

        const response = await api.put(
            `/portfolios/clients/${clientId}/properties/${propertyId}`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message);
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to edit property");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const addPropertyMeter = async (clientId: string, propertyId: string, data: FormData): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.post(`/portfolios/clients/${clientId}/properties/${propertyId}/meters`, data, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
                'Content-Type': 'multipart/form-data', // Important for file uploads
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to add Property");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
}

export const editPropertyMeter = async (clientId: string, propertyId: string, meterId: string, data: FormData): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage
        data.append('_method', 'PUT');

        const response = await api.post(`/portfolios/clients/${clientId}/properties/${propertyId}/meters/${meterId}`, data, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
                'Content-Type': 'multipart/form-data', // Important for file uploads
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to add Property");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
}

export const getMeters = async (clientId: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/portfolios/clients/${clientId}/meters`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Clients");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const grantClientAccess = async (clientId: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.post(`/portfolios/clients/${clientId}/access`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Clients");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
}

export const revokeClientAccess = async (clientId: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.post(`/portfolios/clients/${clientId}/revoke-access`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Clients");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
}

export const revokeClientUserAccess = async (clientId: string, userId: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.post(`/portfolios/clients/${clientId}/revoke-access`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Clients");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
}

export const getClientUsers = async (clientId: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/portfolios/clients/${clientId}/users`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get client users");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};


export const getClientApps = async (clientId: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/portfolios/clients/${clientId}/access`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Clients");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const grantClientAppAccess = async (clientId: string, appId: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage
        console.log(token)
        const response = await api.post(`/portfolios/clients/${clientId}/app/${appId}/access`, {}, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Clients");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
}

export const revokeClientAppAccess = async (clientId: string, appId: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.post(`/portfolios/clients/${clientId}/apps/${appId}/revoke-access`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Clients");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
}

export interface ClientUserData {
    first_name: string;
    last_name: string;
    email_address: string;
    phone_number?: string;
}

export const addClientUser = async (clientId: string, data: ClientUserData): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.post(`/portfolios/clients/${clientId}/users`, data, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to add Client User");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
}

export const getAllClientsMeters = async (): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/portfolios/clients/meters`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Clients");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};